var penthor;
! function(e) {
    "use strict";
    penthor = function() { 
        var a = {
            popupEffect: "",
            supports_html5_storage: !1,
            ajaxLinks: ""
        };
        try {
            a.supports_html5_storage = "sessionStorage" in window && null !== window.sessionStorage, window.sessionStorage.setItem("theme", "test"), window.sessionStorage.removeItem("theme")
        } catch (b) {
            a.supports_html5_storage = !1
        }
        return {
            init: function() {
                this.shopcarousel(), this.oneSlide(), this.brandImage(), this.quote(), this.instagramd(), this.image360(), this.blog(), this.threeslide(), this.slidebuild(), this.center_slide(), this.timeline(), this.slideshow()
            },
            center_slide: function() {
                void 0 !== e(".slider_center").each(function() {
                    e(this).slick({
                        dots: !0,
                        centerMode: !0,
                        slidesToShow: 1,
                        centerPadding: "25%",
                        arrows: !0,
                        autoplay: !0,
                        autoplaySpeed: 6e3,
                        nextArrow: "<button type=\"button\" data-role=\"none\" class=\"slick-next slick-arrow slick-initialized slick-slider\" aria-label=\"Next\" role=\"button\" ><i class=\"las la-angle-left\"></i></button>",
                        prevArrow: "<button type=\"button\" data-role=\"none\" class=\"slick-prev slick-arrow\" aria-label=\"Previous\" role=\"button\" ><i class=\"las la-angle-right\"></i></button>",
                        responsive: [{
                            breakpoint: 768,
                            settings: {
                                centerMode: !0,
                                centerPadding: "20px",
                                slidesToShow: 1
                            }
                        }]
                    })
                })
            },
            slideshow: function() {
                void 0 !== e(".flexslider").each(function() {
                    var a = e(this).data("dots"),
                        c = e(this).data("nav"),
                        b = e(this).data("speed"),
                        d = e(this).data("hover");
                    e(this).flexslider({
                        slideshow: !0,
                        animationDuration: 700,
                        slideshowSpeed: b,
                        controlsContainer: ".flex-controls",
                        controlNav: a,
                        pauseOnHover: d,
                        directionNav: c,
                        prevText: "<span class=\"las la-angle-left\"></span>",
                        nextText: "<span class=\"las la-angle-right\"></span>",
                        keyboardNav: !0
                    }).hover(function() {
                        e(".flex-direction-nav").fadeIn()
                    }, function() {
                        e(".flex-direction-nav").fadeOut()
                    })
                })
            },
            slidebuild: function() {
                void 0 !== e(".carousel-slide.owl-carousel ").each(function() {
                    var a = e(this).data("desktop"),
                        c = e(this).data("tablet"),
                        f = e(this).data("mobile"),
                        g = e(this).data("dot"),
                        d = e(this).data("button"),
                        b = {
                            rtl: e("body").hasClass("rtl"),
                            items: c,
                            responsive: {
                                1200: {
                                    items: a
                                },
                                993: {
                                    items: a
                                },
                                768: {
                                    items: c
                                },
                                479: {
                                    items: f
                                },
                                0: {
                                    items: f
                                }
                            },
                            autoplay: !0,
                            autoplayTimeout: 5e3,
                            dots: g,
                            autoplayHoverPause: !0,
                            nav: d,
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            autoheight: !0,
                            slideBy: "page",
                            loop: !0,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(b)
                })
            },
            shopcarousel: function() {
                void 0 !== e(".slider.owl-carousel ").each(function() {
                    var c = e(this).data("limit"),
                        d = e(this).data("button"),
                        b = e(this).data("dots"),
                        f = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("loop"),
                        g = e(this).data("autoplay"),
                        h = e(this).data("speed"),
                        i = {
                            rtl: e("body").hasClass("rtl"),
                            items: c,
                            responsive: {
                                979: {
                                    items: c
                                },
                                768: {
                                    items: 3
                                },
                                576: {
                                    items: 2
                                },
                                0: {
                                    items: 1
                                }
                            },
                            autoplay: g,
                            autoplayTimeout: 5e3,
                            dots: b,
                            autoplayHoverPause: !0,
                            nav: d,
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            autoheight: !0,
                            slideBy: "page",
                            loop: !0,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(i) 
                })
            }, 
            blog: function() {
                void 0 !== e(".slide-blog.owl-carousel ").each(function() {
                    var b = e(this).data("limit"),
                        c = e(this).data("nav"),
                        d = e(this).data("dots"),
                        f = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("loop"),
                        g = e(this).data("autoplay"),
                        h = {
                            rtl: e("body").hasClass("rtl"),
                            items: b,
                            responsive: {
                                979: {
                                    items: b
                                },
                                768: {
                                    items: 2
                                },
                                479: {
                                    items: 2
                                },
                                0: {
                                    items: 1
                                }
                            },
                            autoplay: !0,
                            autoplayTimeout: 5e3,
                            dots: !0,
                            autoplayHoverPause: !0,
                            nav: !0,
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            autoheight: !0,
                            slideBy: "page",
                            loop: !0,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(h)
                })
            },
            oneSlide: function() {
                void 0 !== e(".one.owl-carousel ").each(function() {
                    var b = e(this).data("limit"),
                        c = e(this).data("button"),
                        d = e(this).data("dots"),
                        f = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("loop"),
                        g = e(this).data("autoplay"),
                        h = {
                            rtl: e("body").hasClass("rtl"),
                            items: 1,
                            autoplay: g,
                            autoplayTimeout: 5e3,
                            dots: d,
                            autoplayHoverPause: !0,
                            nav: c,
                            autoheight: !0,
                            slideBy: "page",
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            loop: !1,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(h)
                })
            },
            threeslide: function() {
                void 0 !== e(".threeslide.owl-carousel ").each(function() {
                    var b = e(this).data("limit"),
                        c = e(this).data("nav"),
                        d = e(this).data("dots"),
                        f = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("loop"),
                        g = e(this).data("autoplay"),
                        h = {
                            rtl: e("body").hasClass("rtl"),
                            items: b,
                            responsive: {
                                979: {
                                    items: 3
                                },
                                768: {
                                    items: 3
                                },
                                479: {
                                    items: 2
                                },
                                0: {
                                    items: 1
                                }
                            },
                            autoplay: !0,
                            autoplayTimeout: 5e3,
                            dots: !0,
                            autoplayHoverPause: !0,
                            nav: !0,
                            autoheight: !0,
                            slideBy: "page",
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            loop: !0,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(h)
                })
            },
            brandImage: function() {
                void 0 !== e(".slide.owl-carousel ").each(function() {
                    var c = e(this).data("limit"),
                        d = e(this).data("button"),
                        b = e(this).data("dots"),
                        f = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("loop"),
                        g = e(this).data("autoplay"),
                        h = {
                            rtl: e("body").hasClass("rtl"),
                            items: c,
                            responsive: {
                                1200: {
                                    items: c
                                },
                                1024: {
                                    items: 5
                                },
                                991: {
                                    items: 4
                                },
                                768: {
                                    items: 4
                                },
                                479: {
                                    items: 3
                                },
                                0: {
                                    items: 2
                                }
                            },
                            autoplay: g,
                            autoplayTimeout: 5e3,
                            dots: b,
                            autoplayHoverPause: !0,
                            nav: d,
                            autoheight: !0,
                            slideBy: "page",
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            loop: !0,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(h)
                })
            },
            quote: function() {
                void 0 !== e(".quotes-slider.owl-carousel ").each(function() {
                    var b = e(this).data("desktop"),
                        c = e(this).data("tablet"),
                        d = e(this).data("mobile"),
                        f = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("loop"),
                        g = e(this).data("autoplay"),
                        h = {
                            rtl: e("body").hasClass("rtl"),
                            items: b,
                            responsive: {
                                979: {
                                    items: b
                                },
                                768: {
                                    items: c
                                },
                                479: {
                                    items: d
                                },
                                0: {
                                    items: d
                                }
                            },
                            autoplay: !0,
                            autoplayTimeout: 5e3,
                            dots: !0,
                            nav: !0,
                            autoheight: !0,
                            autoplayHoverPause: !0,
                            slideBy: "page",
                            navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                            loop: !0,
                            onRefreshed: function() {
                                e(window).resize()
                            }
                        };
                    e(this).owlCarousel(h)
                })
            },
            instagramd: function() {
                void 0 !== e(".instafeed").each(function() {
                    var b = e(this).data("user"),
                        d = e(this).data("token"),
                        f = e(this).data("clienid"),
                        g = (e(this).data("medium"), e(this).data("time")),
                        a = e(this).data("limit"),
                        h = e(this).data("image"),
                        i = e(this).data("arrows"),
                        j = e(this).data("carousel"),
                        c = e(this).data("dots"),
                        k = new Instafeed({
                            get: "user",
                            userId: b,
                            accessToken: d,
                            clientId: f,
                            limit: a,
                            resolution: h,
                            after: function() {
                                setTimeout(function() {
                                    e(".instafeed > a").attr("target", "_blank"), e(".instafeed.slides-owl").owlCarousel({
                                        loop: !1,
                                        margin: 1,
                                        responsiveClass: !0,
                                        dots: c,
                                        nav: i,
                                        navText: ["<i class=\"las la-angle-left\"></i>", "<i class=\"las la-angle-right\"></i>"],
                                        responsive: {
                                            0: {
                                                items: 1
                                            },
                                            600: {
                                                items: 2
                                            },
                                            800: {
                                                items: 3
                                            },
                                            1e3: {
                                                items: j,
                                                loop: !1
                                            }
                                        }
                                    })
                                }, 2e3)
                            }
                        });
                    k.run()
                })
            },
            timeline: function() {
                void 0 !== e(".timeline-block").each(function() {
                    var a = e(this).data("time");
                    e(this).lofCountDown({
                        TargetDate: a,
                        DisplayFormat: "<div class='day'><span class='no'>%%D%%</span><span class='text'>days</span></div><div class='hours'><span class='no'>%%H%%</span><span class='text'>hours</span></div><div class='min'><span class='no'>%%M%%</span><span class='text'>min</span></div><div class='second'><span class='no'>%%S%%</span><span class='text'>sec</span></div>",
                        FinishMessage: "Expired",
                        onRefreshed: function() {
                            e(window).resize()
                        }
                    })
                })
            },
            image360: function() {
                void 0 !== e(".product-image-360").each(function() {
                    var a = e(this).data("allimage"),
                        b = a.split(","),
                        c = b.length;
                    e(".custom_previous").bind("click", function() {
                        car.previous()
                    }), e(".custom_next").bind("click", function() {
                        car.next()
                    }), e(".custom_play").bind("click", function() {
                        car.play(), e(".nav_bar").addClass("play-video")
                    }), e(".custom_stop").bind("click", function() {
                        car.stop(), e(".nav_bar").removeClass("play-video")
                    }), e(this).ThreeSixty({
                        totalFrames: c,
                        endFrame: c,
                        currentFrame: 1,
                        imgList: ".product-images-item",
                        progress: ".spinner",
                        imgArray: b,
                        height: null,
                        width: null,
                        responsive: !0,
                        navigation: !1
                    })
                })
            }
        }
    }()
}(jQuery), jQuery(document).ready(function() {
    penthor.init()
}), jQuery(document).on("shopify:section:load", penthor.shopcarousel).on("shopify:section:unload", penthor.shopcarousel).on("shopify:section:select", penthor.shopcarousel).on("shopify:section:deselect", penthor.shopcarousel).on("shopify:block:select", penthor.shopcarousel).on("shopify:block:deselect", penthor.shopcarousel), jQuery(document).on("shopify:section:load", penthor.quote).on("shopify:section:unload", penthor.quote).on("shopify:section:select", penthor.quote).on("shopify:section:deselect", penthor.quote).on("shopify:block:select", penthor.quote).on("shopify:block:deselect", penthor.quote), jQuery(document).on("shopify:section:load", penthor.instagramd).on("shopify:section:unload", penthor.instagramd).on("shopify:section:select", penthor.instagramd).on("shopify:section:deselect", penthor.instagramd).on("shopify:block:select", penthor.instagramd).on("shopify:block:deselect", penthor.instagramd), jQuery(document).on("shopify:section:load", penthor.brandImage).on("shopify:section:unload", penthor.brandImage).on("shopify:section:select", penthor.brandImage).on("shopify:section:deselect", penthor.brandImage).on("shopify:block:select", penthor.brandImage).on("shopify:block:deselect", penthor.brandImage), jQuery(document).on("shopify:section:load", penthor.oneSlide).on("shopify:section:unload", penthor.oneSlide).on("shopify:section:select", penthor.oneSlide).on("shopify:section:deselect", penthor.oneSlide).on("shopify:block:select", penthor.oneSlide).on("shopify:block:deselect", penthor.oneSlide), jQuery(document).on("shopify:section:load", penthor.timeline).on("shopify:section:unload", penthor.timeline).on("shopify:section:select", penthor.timeline).on("shopify:section:deselect", penthor.timeline).on("shopify:block:select", penthor.timeline).on("shopify:block:deselect", penthor.timeline), jQuery(document).on("shopify:section:load", penthor.image360).on("shopify:section:unload", penthor.image360).on("shopify:section:select", penthor.image360).on("shopify:section:deselect", penthor.image360).on("shopify:block:select", penthor.image360).on("shopify:block:deselect", penthor.image360), jQuery(document).on("shopify:section:load", penthor.blog).on("shopify:section:unload", penthor.blog).on("shopify:section:select", penthor.blog).on("shopify:section:deselect", penthor.blog).on("shopify:block:select", penthor.blog).on("shopify:block:deselect", penthor.blog), jQuery(document).on("shopify:section:load", penthor.slidebuild).on("shopify:section:unload", penthor.slidebuild).on("shopify:section:select", penthor.slidebuild).on("shopify:section:deselect", penthor.slidebuild).on("shopify:block:select", penthor.slidebuild).on("shopify:block:deselect", penthor.slidebuild), jQuery(document).on("shopify:section:load", penthor.slideshow).on("shopify:section:unload", penthor.slideshow).on("shopify:section:select", penthor.slideshow).on("shopify:section:deselect", penthor.slideshow).on("shopify:block:select", penthor.slideshow).on("shopify:block:deselect", penthor.slideshow), jQuery(document).on("shopify:section:load", penthor.center_slide).on("shopify:section:unload", penthor.center_slide).on("shopify:section:select", penthor.center_slide).on("shopify:section:deselect", penthor.center_slide).on("shopify:block:select", penthor.center_slide).on("shopify:block:deselect", penthor.center_slide), jQuery(document).on("shopify:section:load", penthor.threeslide).on("shopify:section:unload", penthor.threeslide).on("shopify:section:select", penthor.threeslide).on("shopify:section:deselect", penthor.threeslide).on("shopify:block:select", penthor.threeslide).on("shopify:block:deselect", penthor.threeslide);